import React, { VFC, VFCX } from 'react';
import { CategoryLabel, CategoryContainer, CategoryTopImage } from './Top';
import NetlifyForm from './netlify-form';
import styled from '@emotion/styled';

const Component: VFC = () => {
  return (
    <CategoryContainer color='var(--color-primary-light)'>
      <CategoryTopImage filename='gummy-coffee.svg' size={18} />
      <CategoryLabel label='お手伝いできること、ありますか？' color='var(--color-text-inverse)' />
      <NetlifyForm />
    </CategoryContainer>
  );
};

export default Component;
